export default __webpack_public_path__ + "static/media/icon_certo.79eb3927.svg";